/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { QuoteGroupCarrierResult } from "./QuoteGroupCarrierResult";
import {
  QuoteGroupCarrierResultFromJSON,
  QuoteGroupCarrierResultFromJSONTyped,
  QuoteGroupCarrierResultToJSON,
  QuoteGroupCarrierResultToJSONTyped,
} from "./QuoteGroupCarrierResult";
import type { ProcessingState } from "./ProcessingState";
import {
  ProcessingStateFromJSON,
  ProcessingStateFromJSONTyped,
  ProcessingStateToJSON,
  ProcessingStateToJSONTyped,
} from "./ProcessingState";

/**
 *
 * @export
 * @interface QuoteGroupStateResponse
 */
export interface QuoteGroupStateResponse {
  /**
   *
   * @type {ProcessingState}
   * @memberof QuoteGroupStateResponse
   */
  state: ProcessingState;
  /**
   *
   * @type {number}
   * @memberof QuoteGroupStateResponse
   */
  quoteCount: number;
  /**
   *
   * @type {Array<QuoteGroupCarrierResult>}
   * @memberof QuoteGroupStateResponse
   */
  carrierResults: Array<QuoteGroupCarrierResult>;
}

/**
 * Check if a given object implements the QuoteGroupStateResponse interface.
 */
export function instanceOfQuoteGroupStateResponse(
  value: object,
): value is QuoteGroupStateResponse {
  if (!("state" in value) || value["state"] === undefined) return false;
  if (!("quoteCount" in value) || value["quoteCount"] === undefined)
    return false;
  if (!("carrierResults" in value) || value["carrierResults"] === undefined)
    return false;
  return true;
}

export function QuoteGroupStateResponseFromJSON(
  json: any,
): QuoteGroupStateResponse {
  return QuoteGroupStateResponseFromJSONTyped(json, false);
}

export function QuoteGroupStateResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteGroupStateResponse {
  if (json == null) {
    return json;
  }
  return {
    state: ProcessingStateFromJSON(json["state"]),
    quoteCount: json["quoteCount"],
    carrierResults: (json["carrierResults"] as Array<any>).map(
      QuoteGroupCarrierResultFromJSON,
    ),
  };
}

export function QuoteGroupStateResponseToJSON(
  json: any,
): QuoteGroupStateResponse {
  return QuoteGroupStateResponseToJSONTyped(json, false);
}

export function QuoteGroupStateResponseToJSONTyped(
  value?: QuoteGroupStateResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    state: ProcessingStateToJSON(value["state"]),
    quoteCount: value["quoteCount"],
    carrierResults: (value["carrierResults"] as Array<any>).map(
      QuoteGroupCarrierResultToJSON,
    ),
  };
}
